import TalkRoomApiRequest from "@/apiRequests/resources/communityTalk/talkRoomApiRequest";
import LayoutTagApiRequest from "@/apiRequests/resources/communityTalk/layoutTagApiRequest";
import { TalkRoomResponse } from "@/apiRequests/models/communityTalk/talkRoomGetResponse";
import { LayoutTagGetResponse } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";
import { TalkRoomGetRequest } from "@/apiRequests/models/communityTalk/talkRoomGetRequest";
import { LayoutTagGetRequest } from "@/apiRequests/models/communityTalk/layoutTagGetRequest";
import { TalkRoomPostRequest } from "@/apiRequests/models/communityTalk/talkRoomPostRequest";
import { TalkRoomPostResponse } from "@/apiRequests/models/communityTalk/talkRoomPostResponse";

export default class TalkRoomDomain {
	private readonly _talkRoomApiRequest: TalkRoomApiRequest;
	private readonly _layoutTagApiRequest: LayoutTagApiRequest;

	/**
	 * コンストラクタ。
	 */
	constructor() {
		this._talkRoomApiRequest = new TalkRoomApiRequest();
		this._layoutTagApiRequest = new LayoutTagApiRequest();
	}

	/**
	 * トークルーム取得APIへのリクエスト。
	 */
	public async getTalkRoomData(tenantId: string, tagCd: string, subjectCd: string, count: number, talkRoomSortType: string, lastTalkRoomSortKey?: string): Promise<TalkRoomResponse> {
		// APIリクエスト用にデータ成形
		let request: TalkRoomGetRequest = {
			tenantId: tenantId,
			tagCd: tagCd,
			subjectCd: subjectCd,
			count: count,
			talkRoomSortType: talkRoomSortType,
		};
		if (lastTalkRoomSortKey) {
			request = {
				...request,
				lastTalkRoomSortKey: lastTalkRoomSortKey,
			};
		}

		try {
			return await this._talkRoomApiRequest.getTalkRooms(tenantId, request);
		} catch (e) {
			throw new Error();
		}
	}

	/**
	 * 表示タグ設定取得APIへのリクエスト。
	 */
	public async getLayoutTagData(tenantId: string, tagCd: string): Promise<LayoutTagGetResponse> {
		// APIリクエスト用にデータ成形
		const request: LayoutTagGetRequest = {
			tenantId: tenantId,
			tagCd: tagCd,
		};

		try {
			return await this._layoutTagApiRequest.getLayoutTags(tenantId, request);
		} catch (e) {
			throw new Error();
		}
	}

	/**
	 * トークルーム投稿APIへのリクエスト。
	 */
	public async postTalkRoomData(request: TalkRoomPostRequest, tenantId: string): Promise<TalkRoomPostResponse> {
		return await this._talkRoomApiRequest.postTalkRooms(tenantId, request);
	}
}
